import React, {useState, ReactElement, useEffect} from 'react';
import {Menu, MenuItem, IconButton} from '@mui/material';
import AurGroupAvatar from '../common/aur-group-avatar/AurGroupAvatar';
import AurIcon, {IconColors, IconNames} from '../common/aur-icon/AurIcon';
import {useSelector} from 'react-redux';
import {getProfileAvtarBGColor} from '../../redux/slices/userSlice';
import {t} from 'i18next';

interface User {
  name: string;
  surname: string;
  color?: string; // Color will be optional, can be randomly generated
}

interface AurUserProfileProps {
  user: User;
  menuItems?: {
    label: string | ReactElement;
    icon?: ReactElement;
    onClick?: () => void;
  }[];
}

const AurUserProfile: React.FC<AurUserProfileProps> = ({user, menuItems}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const profileAvtarBGColor = useSelector(getProfileAvtarBGColor);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Create a state to hold the user with color assigned on the first render
  const [userWithColor, setUserWithColor] = useState<User>(user);

  useEffect(() => {
    if (!user.color) {
      setUserWithColor({...user, color: profileAvtarBGColor});
    }
  }, [user]);

  return (
    <>
      <IconButton
        onClick={handleClick}
        className="user-profile-menu-icon-btn"
        size="large"
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <div className="avatar-icon">
          <AurGroupAvatar users={[userWithColor]} maxVisible={1} />
        </div>
        <div className="caret-icon">
          <AurIcon
            icon={open ? IconNames.CaretUp : IconNames.CaretDown}
            color={IconColors.Custom}
            size="large"
            customClassName="expand-more-icon"
          />
        </div>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        className="aur-user-profile-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{horizontal: 'right', vertical: 'top'}}
        anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
        disableScrollLock
      >
        {menuItems && menuItems.length > 0 ? (
          menuItems.map((item, index) => (
            <MenuItem
              key={index}
              onClick={() => {
                handleClose();
                if (item.onClick) item.onClick();
              }}
            >
              {item.icon && <span>{item.icon}</span>}
              {item.label}
            </MenuItem>
          ))
        ) : (
          <MenuItem onClick={handleClose}>
            {t('common.defaultMenuItem')}
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default AurUserProfile;
